/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"

function SEO({ description, lang, meta, title, image }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
            social {
              twitter
            }
          }
        }
      }
    `
  )

  const { pathname } = useLocation()
  const { siteUrl } = site.siteMetadata
  const url = `${siteUrl}${pathname}`

  const metaDescription = description || site.siteMetadata.description

  // Use the site's title as the title for the root page
  const metaTitle = title === "<index>" ? `${site.siteMetadata.title}` : title

  // Ensure image is an absolute url
  if (image && !image.includes("://")) {
    image = `${siteUrl}${image}`
  }

  const metaTags = [
    {
      name: `description`,
      content: metaDescription,
    },
    {
      property: `image`,
      content: image,
    },
    {
      property: `og:url`,
      content: url,
    },
    {
      property: `og:title`,
      content: metaTitle,
    },
    {
      property: `og:description`,
      content: metaDescription,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      property: `og:image`,
      content: image,
    },
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:image`,
      content: image,
    },
    {
      name: `twitter:creator`,
      content: site.siteMetadata.social.twitter,
    },
    {
      name: `twitter:title`,
      content: metaTitle,
    },
    {
      name: `twitter:description`,
      content: metaDescription,
    },
    {
      name: `flattr:id`,
      content: "g6rr50",
    },
  ].concat(meta)

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      titleTemplate={
        metaTitle === site.siteMetadata.title
          ? `%s`
          : `%s | ${site.siteMetadata.title}`
      }
    >
      {metaTags.map((metaTag, index) => (
        <meta key={index} {...metaTag} />
      ))}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
